import React from 'react';
import { IconChevronRight } from '@tabler/icons-react';

interface TabState {
  name: string;
  params: string;
  data: string;
}

type Props = {
  tab: TabState;
  tabHistory: TabState[];
  goBack: () => void;
};

export default function BreadCrumbs({ tab, tabHistory, goBack }: Props) {
  return (
    <div>
      {tabHistory?.[1]?.name && (
        <div className="flex items-center bg-white border border-[#d2d2d2] w-fit rounded-md p-3 py-1 font-medium space-x-2 text-black/70 text-sm">
          {tabHistory.map((t, index) => {
            const label =
              t?.name === 'loc' ? 'Country' : t?.name?.[0]?.toUpperCase() + t?.name?.slice(1);
            const isClickable = index === tabHistory.length - 2;

            return (
              <div key={t.name} className="flex items-center">
                <span
                  onClick={() => isClickable && goBack()}
                  className={`${t.data === tab.data ? 'text-black' : ''}
                  ${isClickable ? 'cursor-pointer text-[#FBD037]' : 'cursor-default text-gray-500'}
                `}
                >
                  {label}
                </span>
                {index < tabHistory.length - 1 && <IconChevronRight size={20} />}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
